import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icons-nav-item-home-1c35b",
  "use": "icons-nav-item-home-1c35b-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"currentColor\" viewBox=\"0 0 16 16\" id=\"icons-nav-item-home-1c35b\"><path d=\"m8.501 1.008 6.042 5.437.248.224v8.122H1.208V6.669l.248-.224 6.042-5.437L8 .557zM2.708 7.337v5.954H7.25v-2.874h1.5v2.874h4.541V7.336L7.999 2.574z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol